import PropTypes from 'prop-types'

import { AdasTextField } from '@components/wrapper-components'
import { useIsReadOnly } from '@hooks/useIsReadOnly'
import { Plus, Search } from 'lucide-react'
import { cn } from 'lib/utils'

export const SearchOrAddData = ({
  searchInput,
  searchInputHandler,
  searchInputPlaceholder,
  onAddClick,
  searchPlaceholder = 'Search...',
  variant = 'withAddButton',
  maxHeight,
  sx
}) => {
  // Shared by the client, user and contact lists: dropping the add affordance here
  // covers all of them, and the search half of the control still works.
  const isReadOnly = useIsReadOnly()
  const showAddButton = !isReadOnly && (variant === 'withAddButton' || variant === 'withAddButtonDisabled')
  const isButtonDisabled = variant === 'withAddButtonDisabled'

  return (
    <div className='flex items-stretch w-full'>
      <AdasTextField
        className={cn('flex-1', '[&_input]:pl-9', showAddButton && '[&_input]:rounded-r-none [&_input]:border-r-0')}
        onChange={searchInputHandler}
        id='search'
        name='search'
        placeholder={searchInputPlaceholder || searchPlaceholder}
        type='text'
        value={searchInput}
        fullWidth
        InputProps={{
          startAdornment: <Search className='h-4 w-4 text-muted-foreground' />
        }}
      />
      {showAddButton && (
        <button
          onClick={onAddClick}
          disabled={isButtonDisabled}
          aria-label='Add'
          className={cn(
            'inline-flex items-center justify-center h-11 w-12',
            'rounded-r-lg rounded-l-none',
            'bg-sidebar text-white hover:bg-sidebar/90',
            'border border-l-0 border-sidebar',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            'transition-colors shrink-0'
          )}
        >
          <Plus className='h-5 w-5' />
        </button>
      )}
    </div>
  )
}

SearchOrAddData.propTypes = {
  searchInput: PropTypes.string.isRequired,
  searchInputHandler: PropTypes.func.isRequired,
  searchInputPlaceholder: PropTypes.string,
  onAddClick: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  maxHeight: PropTypes.string,
  variant: PropTypes.oneOf(['withAddButton', 'withoutAddButton', 'withAddButtonDisabled'])
}
